import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dtComponenthost]',
  standalone: false
})
export class ComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
